module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['global-auth-box d-flex justify-center align-center', {
      hide: !_vm.show
    }],
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "g-auth-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "back-box"
  }, [_c('span', {
    on: {
      "click": _vm.showGlobalLogin
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  }), _vm._v("\n        Login\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-title"
  }, [_vm._v("Sign Up")]), _vm._v(" "), (_vm.step === 1) ? _c('div', [_c('div', [_vm._v("To begin, please enter your mobile number.")]), _vm._v(" "), _c('mobile-input', {
    ref: "userMobile",
    attrs: {
      "needVerification": false,
      "mobile": _vm.mobile,
      "uniqID": 'mobile1',
      "dialCode": _vm.countryCode,
      "required": true,
      "hasError": _vm.error.fields.indexOf('mobile') > -1
    },
    on: {
      "updateMobile": _vm.updateMobileInfo
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', [_c('div', [_vm._v("\n        Please enter the verification code we sent to\n        "), _c('b', [_vm._v("+" + _vm._s(_vm.countryCode) + _vm._s(_vm.mobile))])]), _vm._v(" "), _c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('pin') > -1
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pin),
      expression: "pin"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Type in the verification code here.",
      "disabled": _vm.mobileLoading
    },
    domProps: {
      "value": (_vm.pin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pin = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', [_c('div', {
    staticClass: "d-flex justify-space-between",
    staticStyle: {
      "gap": "10px"
    }
  }, [_c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('gender') > -1
    }],
    on: {
      "change": function($event) {
        _vm.gtagTrack('gender')
      }
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    class: ['pax-bday', {
      'has-error': _vm.error.fields.indexOf('gender') > -1
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Female"
    }
  }, [_vm._v("Female")])])]), _vm._v(" "), _c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('title') > -1
    }],
    on: {
      "change": function($event) {
        _vm.gtagTrack('title')
      }
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    class: ['pax-bday', {
      'has-error': _vm.error.fields.indexOf('title') > -1
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mr"
    }
  }, [_vm._v("Mr.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ms"
    }
  }, [_vm._v("Ms.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mrs"
    }
  }, [_vm._v("Mrs.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Miss"
    }
  }, [_vm._v("Miss")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mstr"
    }
  }, [_vm._v("Mstr")])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-space-between",
    staticStyle: {
      "gap": "10px"
    }
  }, [_c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('firstName') > -1
    }],
    on: {
      "change": function($event) {
        _vm.gtagTrack('firstName')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('lastName') > -1
    }],
    on: {
      "change": function($event) {
        _vm.gtagTrack('lastName')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pax-field d-flex justify-space-between",
    staticStyle: {
      "gap": "10px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthMonth),
      expression: "birthMonth"
    }],
    class: ['pax-bday', {
      'has-error': _vm.error.fields.indexOf('birthMonth') > -1
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.birthMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Birth Month")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v("Jan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Feb")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("Mar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "04"
    }
  }, [_vm._v("Apr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("May")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("Jun")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Jul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("Aug")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("Sep")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Oct")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Nov")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Dec")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthDay),
      expression: "birthDay"
    }],
    class: ['pax-bday', {
      'has-error': _vm.error.fields.indexOf('birthDay') > -1
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.birthDay = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Birth Day")]), _vm._v(" "), _vm._l((31), function(x) {
    return _c('option', {
      key: x,
      domProps: {
        "value": x
      }
    }, [_vm._v(_vm._s(x))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birthYear),
      expression: "birthYear"
    }],
    class: ['pax-bday', {
      'has-error': _vm.error.fields.indexOf('birthYear') > -1
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.birthYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Birth Year")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.currentYear
    }
  }, [_vm._v(_vm._s(_vm.currentYear))]), _vm._v(" "), _vm._l((99), function(x) {
    return _c('option', {
      key: x,
      domProps: {
        "value": _vm.currentYear - x
      }
    }, [_vm._v(_vm._s(_vm.currentYear - x))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-space-between",
    staticStyle: {
      "gap": "10px"
    }
  }, [_c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('address') > -1
    }],
    on: {
      "change": function($event) {
        _vm.gtagTrack('address')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('city') > -1
    }],
    on: {
      "change": function($event) {
        _vm.gtagTrack('city')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    attrs: {
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-space-between",
    staticStyle: {
      "gap": "10px"
    }
  }, [_c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('zip') > -1
    }],
    on: {
      "change": function($event) {
        _vm.gtagTrack('zip')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip),
      expression: "zip"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Zip"
    },
    domProps: {
      "value": (_vm.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pax-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    class: ['country-selector', {
      'has-error': _vm.error.fields.indexOf('country') > -1
    }],
    attrs: {
      "placeholder": "Country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Country")]), _vm._v(" "), _vm._l((_vm.countryList), function(country, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": country.code
      }
    }, [_vm._v(_vm._s(_vm.cleanCountryName(country.name)))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pax-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passportNum),
      expression: "passportNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Passport Number (Optional)",
      "autocomplete": "one-time-code"
    },
    domProps: {
      "value": (_vm.passportNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passportNum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('email') > -1
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email",
      "autocomplete": "one-time-code"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.gtagTrack('email')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "gap": "10px"
    }
  }, [_c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('password') > -1
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "autocomplete": "one-time-code"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: ['pax-field', {
      'has-error': _vm.error.fields.indexOf('rpassword') > -1
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rpassword),
      expression: "rpassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Repeat Password",
      "autocomplete": "one-time-code"
    },
    domProps: {
      "value": (_vm.rpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rpassword = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.error.msg.length) ? _c('div', {
    staticClass: "error-msg"
  }, [(_vm.error.msg.indexOf('E_EMAIL_EXISTS') > -1) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.$t('customerForm.emailExist')) + "\n        "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.initShowLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('customerForm.clickHere')))]), _vm._v(" \n        " + _vm._s(_vm.$t('customerForm.toSignIn')) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('customerForm.otherwisePlease')) + "\n      ")]) : _vm._l((_vm.error.msg), function(err, e) {
    return _c('div', {
      key: e
    }, [_vm._v("- " + _vm._s(err))])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['op-btn btn-md btn-block btn-success signup-btn', {
      disabled: _vm.mobileLoading
    }],
    on: {
      "click": _vm.submit
    }
  }, [(_vm.mobileLoading) ? _c('i', {
    staticClass: "fas fa-spinner fa-spin slow-spin fa-fw"
  }) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('span', [((_vm.countryCode === _vm.firstVisit.countryCode && _vm.mobile === _vm.firstVisit.mobile && _vm.firstVisit.mobile) || _vm.global.userInfo.verifiedNumber.indexOf(("" + _vm.countryCode + _vm.mobile)) > -1) ? _c('span', [_vm._v("NEXT")]) : _c('span', [_vm._v("SEND VERIFICATION CODE")])]) : (_vm.step === 2) ? _c('span', [_vm._v("VERIFY")]) : _c('span', [_vm._v("SIGN UP")])]), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    class: ['resend-txt', {
      disabled: _vm.resendTimer > 0
    }],
    on: {
      "click": _vm.resendPin
    }
  }, [_vm._v("\n        Resend Verification Code\n        "), (_vm.resendTimer > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.resendTimer) + "s)")]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d3c16a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d3c16a6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/GlobalSignup.vue
// module id = 2032
// module chunks = 0